import React from "react";
import { useNavigate } from "react-router-dom";

import './PageABMs.css';

import Routes_gral from "../../utils/Routes_gral";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faUsersBetweenLines,
  faHouse,
  faBasketShopping,
  faPlusSquare,
  faUsers,
  faCubes,
  faPenToSquare,
  faList,
  faToolbox,
  faFolder,
  faLayerGroup,
  faFaceSmile,
  faCartShopping,
  faSquareCheck,
  faScrewdriverWrench,
  faCalendarDays,
  faTableCells,
  faObjectGroup,
  faBook,
  faFileLines,
  faBan
} from "@fortawesome/free-solid-svg-icons";

import DiamondIcon from '@mui/icons-material/Diamond';

const PageABMs = () =>{

    const navigate = useNavigate();

    const navigateTo = (abm) =>{
        navigate(abm);
    }

    return <div className="pageABMsView">
        <div className="multipleOptionsDiv">
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.categoriasRRHH)}>
                    <FontAwesomeIcon icon={faLayerGroup} className='iconAbm'/>
                    <label className="labelOptionABM">Categorias RRHH</label> 
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.legajos)}>
                    <FontAwesomeIcon icon={faFaceSmile} className='iconAbm'/>
                    <label className="labelOptionABM">Legajos</label> 
                </button>            
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.proveedores)}>
                    <FontAwesomeIcon icon={faCartShopping} className='iconAbm'/>
                    <label className="labelOptionABM">Proveedores</label> 
                </button>            
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.control)}>
                    <div className='iconAbm'>
                        <DiamondIcon style={{pointerEvents:"none"}} className="abmChildIcon"/>
                        <DiamondIcon style={{pointerEvents:"none"}} className="abmChildIcon"/>
                    </div>
                    <label className="labelOptionABM">Activos</label> 
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.procedimientos)}>
                    <FontAwesomeIcon icon={faToolbox} className='iconAbm'/>
                    <label className="labelOptionABM">Procedimientos</label> 
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.product)}>
                    <FontAwesomeIcon icon={faBasketShopping} className='iconAbm'/>
                    <label className="labelOptionABM">Productos</label> 
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.checkList)}>
                    <FontAwesomeIcon icon={faSquareCheck} className='iconAbm'/>
                    <label className="labelOptionABM">Checklist</label> 
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.user)}>
                    <FontAwesomeIcon icon={faUsers} className='iconAbm'/>
                    <label className="labelOptionABM">Usuarios</label> 
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.group)}>
                    <FontAwesomeIcon icon={faUsersBetweenLines} className='iconAbm'/>
                    <label className="labelOptionABM">Grupos</label>
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.templatesProduccion)}>
                    <FontAwesomeIcon icon={faFileLines} className='iconAbm'/>
                    <label className="labelOptionABM">Templates Prod.</label>
                </button>
            </div>
            <div className="optionABMDiv">
                <button onClick={()=>navigateTo(Routes_gral.bloqueadosReserva)}>
                    <FontAwesomeIcon icon={faBan} className='iconAbm'/>
                    <label className="labelOptionABM">Bloqueados para Reservar</label>
                </button>
            </div>
        </div>
    </div>

}

export default PageABMs;